import { addDays } from "date-fns";

export const getWeekDates = (weekDate: Date) => {
  const dayOfWeek = weekDate.getDay() || 7;
  const firstDay = addDays(weekDate, 1 - dayOfWeek);
  const offsets = [0, 1, 2, 3, 4, 5, 6];
  return offsets.map((offset) => addDays(firstDay, offset));
};
